import { CRUD, CrudModel } from '../../classes/crud.class'
import { PortalSystem } from '../portal/portal-system'
import { PortalData } from './portal.data'

@CRUD({
  base: '/crud/portal',
})
export class PortalModel extends CrudModel {
  public name!: string
  public portalSystemId!: string
  public portalSystem?: PortalSystem

  constructor(data: PortalData) {
    super(data, true)

    if (data.portalSystem) {
      this.portalSystem = data.portalSystem
    }
  }

  override toJSON() {
    return {
      ...super.toJSON(),
      name: this.name,
      portalSystemId: this.portalSystemId,
    }
  }
}
